module.exports = __webpack_public_path__ + "static/media/procedures.8da70d5c.svg";